<script>
import Presenter from './Presenter'

import RightPlus from './svg/RightPlus'

export default {
  name: 'AppIcon',
  components: {
    RightPlus,
  },
  extends: Presenter,
  props: {
    ...Presenter.props,
  },
}
</script>
